/**
 * Debounce falls under a similar category as Throttle.
 * For debounce, it waits till the actions has stopped in order to execute the code.
 * Throttle, on the otherhand, will run even with user interactions, but only once per set interval.
 *
 * Example where a user clicks a 1000 times in 1 second
 * - No throttle/debounce: makes function call 1000 times
 * - Debounce: Will only run function once after the 1000th click
 * @param {VoidFn} task - the function that is expected to be ran after the assigned waiting period of inactivity
 * @param {number} delay - How long, in milliseconds, to wait for inactivity to run the task
 */
const debounce = (task, delay) => {
    let timer;
    return () => {
        clearTimeout(timer);
        timer = setTimeout(task, delay);
    };
};
export default debounce;
